import React, { useState, useMemo, useEffect } from "react";
import { MdOutlineAdd, MdOutlineEdit, MdSettings } from "react-icons/md";
import { FcAbout } from "react-icons/fc";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from "react-i18next";
import { getUserRolePermissions, getUsers, updateUserRole,registerUsersBulk, getUserInfo, getInfouserById} from "../../services/userServicer";
import i18n from "../../i18n";
import { jwtDecode } from "jwt-decode";
import "./style.css"

// Fix the import in UserManage.tsx
import { RoleModal } from "./popupRole";
import * as XLSX from 'xlsx';
import { TfiImport } from "react-icons/tfi";
import { CiExport } from "react-icons/ci";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingScreen from "src/Loading/LoadingScreen";
import { getFunctions, updateUserFunctions } from "src/services/functions";

interface UserData {
  id: string;
  code: string;
  username: string;
  name: string;
  email: string;
  role: string;
  index: number;
}
const roles = ["Supervisor", "Admin", "Leader", "Implementor"];

const UserManage: React.FC = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [selectedRole, setSelectedRole] = useState("");
  const [data, setData] = useState<UserData[]>([]);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [perPage, setPerPage] = useState<number>(10);
  const navigate = useNavigate();
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [rowId, setRowId] = useState<string>("");
  const [rowStatus, setRowStatus] = useState<string>("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState<{
    key: keyof UserData | "index";
    direction: "ascending" | "descending" | null;
  }>({ key: "index", direction: "ascending" });

  const [userPermissions, setUserPermissions] = useState<any>(null); // Add state for user permissions
  const [notAllowed, setNotAllowed] = useState(false);
  const [loading, setLoading] = useState(false); // Add loading state

  const [isFunctionModalOpen, setIsFunctionModalOpen] = useState(false);
const [functionList, setFunctionList] = useState([]);
const [userFunctionIds, setUserFunctionIds] = useState<string[]>([]);

const openFunctionModal = async (userId: string) => {
  setSelectedUserId(userId);

  // Fetch all functions and assigned user functions first
  const [allFunctionsResponse, userDetails] = await Promise.all([
    getFunctions(),
    getInfouserById(userId),
  ]);

  const functions = allFunctionsResponse?.data || [];

  // Set both before opening the modal
  setFunctionList(functions);
setUserFunctionIds(userDetails?.functions?.map((f: { functionId: string }) => f.functionId) || []);
  setIsFunctionModalOpen(true); // ✅ Now open modal AFTER states are set
};



const toggleFunctionSelection = (id: string) => {
  setUserFunctionIds(prev =>
    prev.includes(id) ? prev.filter(fid => fid !== id) : [...prev, id]
  );
};
const submitUserFunctions = async () => {
  try {
    const res = await updateUserFunctions(selectedUserId!, userFunctionIds); // ✅ pass array directly

    if (res?.success) {
      toast.success("Functions updated successfully.");
      setIsFunctionModalOpen(false);
    } else {
      toast.error(res?.message || "Failed to update functions.");
    }
  } catch (err: any) {
    toast.error("Error updating functions.");
  }
};



  const fetchUsersData = async (page: number) => {
    setLoading(true); // Set loading to true when fetching data
    try {
      const response: any = await getUsers("", perPage, page);
      if (response && response.success) {
        const indexedData = response.data.map((user: UserData, idx: number) => ({
          ...user,
          index: idx + 1 + page * perPage,
        }));
        setData(indexedData);
        setTotalPages(Math.ceil(response.totalCount / perPage));
      } else if (response && response.data.length === 0) {
        setData([]);
        setTotalPages(0);
      } else {
        toast.error("Failed to fetch users data");
      }
    } catch (error: any) {
      toast.error("Error fetching users data:", error);
    } finally {
      setLoading(false); // Set loading to false after fetching data
    }
  };

  const openRoleModal = (userId: string, currentRole: string) => {
    setSelectedUserId(userId);
    setSelectedRole(currentRole);
    setIsModalOpen(true);
  };

  function getRole() {
    const token = localStorage.getItem("d_c_c_t");
    if (!token) return null;
  
    try {
      const decoded:any = jwtDecode(token);
      return decoded.groupName || null;
    } catch (error) {
      console.error("Invalid token in getRole():", error);
      return null;
    }
  }

  const handleRoleChange = async (newRole: string) => {
    if (!selectedUserId) return;
    try {
      //console.log(selectedUserId)
      //console.log(newRole)


      const response = await updateUserRole(selectedUserId, { groupName: newRole });
      //console.log(response)
      if (response?.success) {
        toast.success("Role updated successfully");
  
        // Update the user role directly in the state
        const updatedData = data.map((user) =>
          user.id === selectedUserId ? { ...user, role: newRole } : user
        );
      //console.log(updatedData)

        setData(updatedData);
  
        fetchUsersData(currentPage);
      } else {
        toast.error("Failed to update the role");
      }
    } catch (error) {
      toast.error("Error occurred while updating the role");
    } finally {
      setIsModalOpen(false);
    }
  };


     const downloadExampleExcel = () => {
      const exampleData = [
        {
          firstName: 'test',
          lastName: 'test',
          username: 'test',
          email: 'test.test@example.com',
          address: '123 Main St',
          phone: '01234567890',
          password: 'Password123',
          group:"Compliance_Manager"
        },
        {
          firstName: 'test2',
          lastName: 'test2',
          username: 'test2',
          email: 'test2.test2@example.com',
          address: '456 Elm St',
          phone: '01234567890',
          password: 'SecurePass456',
          group:"Compliance_Implementer"
        },
      ];
  
      const worksheet = XLSX.utils.json_to_sheet(exampleData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Example');
  
      
      XLSX.writeFile(workbook, 'Organizations_Template.xlsx');
  
      
    };
  // Handle Import and Upload
  const handleImportAndUpload = (file: File) => {
    const reader = new FileReader();
  
    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
  
        if (jsonData.length === 0) {
          toast.error("No data found in the uploaded file.");
          return;
        }
  
        //console.log('Uploading data:', jsonData);
  
        const result = await registerUsersBulk(jsonData);
  
        if (result.success) {
          toast.success(`users registered successfully`);
          fetchUsersData(currentPage)

        } else {
          toast.error(`Failed to register some users: ${result.message}`);
        }
      } catch (error: any) {
        console.error("Upload Error:", error);
        toast.error(error.message || "Unexpected error occurred during upload.");
      }
    };
  
    reader.readAsArrayBuffer(file);
  };

  

  useEffect(() => {
    const fetchUserRolePermissions = async () => {
      try {
        const user = await getUserInfo();
        if (!user?.id) return;
        let userId =  user.id || "";
        const permissions = await getUserRolePermissions(userId);
        //console.log(permissions);
        if (permissions.success) {
          // Access the permissions for the "Users" page from the permissions array
          const userPagePermission: any = permissions.data.permissions.find(
            (permission: any) => permission.page === "Users"
          );

          if (userPagePermission) {
            // Normalize permissions and map additional flags for easier usage in UI
            const normalizedPermissions = {
              ...userPagePermission,
              // Map "First Approval" to a generic approve flag (similar to Compliance page)
              approve:
                userPagePermission.approve ??
                userPagePermission["First Approval"] ??
                false,
              // Treat create as upload permission for bulk import
              upload:
                userPagePermission.upload ??
                userPagePermission.create ??
                false,
            };

            setUserPermissions(normalizedPermissions);
            setNotAllowed(!normalizedPermissions.show);
          } else {
            setNotAllowed(true);
          }
        } else {
          setNotAllowed(true);
        }
      } catch (error: any) {
        toast.error(t("permissions.Error_fetching_user_role_permissions") + ":", error);
        setNotAllowed(true);
      }
    };

    fetchUserRolePermissions();
    fetchUsersData(currentPage);
  }, [perPage, currentPage]);

  const sortedData = useMemo(() => {
    let sortableData = [...data];
    if (sortConfig.direction !== null) {
      sortableData.sort((a: any, b: any) => {
        if (sortConfig.key === "index") {
          return sortConfig.direction === "ascending" ? a.index - b.index : b.index - a.index;
        }
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [data, sortConfig, currentPage, perPage]);

  const filteredData = useMemo(() => {
    const filtered = sortedData.filter((item) => {
      return (
        item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.role?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
    return filtered;
  }, [sortedData, searchTerm, currentPage, perPage]);

  useEffect(() => {
    setCurrentPage(0);
  }, [searchTerm]);

  const toggleSort = (key: keyof UserData | "index") => {
    let direction: "ascending" | "descending" | null = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    } else if (sortConfig.key === key && sortConfig.direction === "descending") {
      direction = null;
    }
    setSortConfig({ key, direction });
  };

  if (loading) {
    return (
      <div className="loading-screen" 
      style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.8)'}}>
                     <div><LoadingScreen/></div>
                   </div>
    );
  }

  return (
    <>
   
      <div className="root">
     
              {/* Buttons for Download and Import */}
              {getRole()==="Compliance_Leader"||getRole()==="Super Admin"&&



           <div className="d-flex justify-content-between align-items-center p-2">
           <h4 className="px-3" >{t("User_Manage.page_title_user_manage")}</h4>
           <div className="d-flex gap-2">
           <input
  type="file"
  accept=".xlsx, .xls"
  onChange={(e) => {
    const file = e.target.files?.[0];
    if (!userPermissions?.upload) {
      toast.error(t("permissions.Upload_not_allowed") || "You do not have permission to upload.");
      return;
    }
    if (file) {
      handleImportAndUpload(file);
    } else {
      toast.error(t("error.no_file_selected"));
    }
  }}
  style={{ display: "none" }}
  id="import-excel"
/>

             <label htmlFor="import-excel" className="btn-upload text-center d-flex align-items-center justify-content-center" style={{ width: "250px" }}>
               <TfiImport className="me-2 mb-1" size={12} /> {t("Standards_Page.import_excel")}
             </label>
             <button className="btndoweload d-flex align-items-center" onClick={downloadExampleExcel}>
               <CiExport className="me-2" size={16} />
               {t("Standards_Page.download_excel_template")}
             </button>
           </div>
         </div>
         
              }
            
            <div className="d-flex justify-content-between my-2 bg-white border-Card rounded p-4">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder={t("User_Manage.search_placeholder") || ""}
                className="search-input"
              />
            </div>
        {!notAllowed && (
        <div className="container_info  rounded" >
            
        <table className="styled-table">
              <thead>
                <tr>
                  <th onClick={() => toggleSort("index")} className="sortable-header">
                    #
                    {sortConfig.key === "index" ? (sortConfig.direction === "ascending" ? "🔼" : "🔽") : ""}
                  </th>
                  <th onClick={() => toggleSort("username")} className="sortable-header">
                    {t("User_Manage.username")}
                    {sortConfig.key === "username" ? (sortConfig.direction === "ascending" ? "🔼" : "🔽") : ""}
                  </th>
                  <th onClick={() => toggleSort("name")} className="sortable-header">
                    {t("User_Manage.name")}
                    {sortConfig.key === "name" ? (sortConfig.direction === "ascending" ? "🔼" : "🔽") : ""}
                  </th>
                  <th onClick={() => toggleSort("email")} className="sortable-header">
                    {t("User_Manage.email")}
                    {sortConfig.key === "email" ? (sortConfig.direction === "ascending" ? "🔼" : "🔽") : ""}
                  </th>
                  <th>{t("User_Manage.role")}</th>
                  <th className="d-flex justify-content-center align-items-center text-center">{t("User_Manage.actions")}</th>
                </tr>
              </thead>
              {data.length > 0 && (
                <tbody>
                  {filteredData.map((item: any, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item.username}</td>
                        <td>{item.name}</td>
                        <td>{item.email}</td>
                        <td>{item.role}</td>
                        <td>
                          <div>
                          {userPermissions?.edit &&
                           <button
                           onClick={() => openRoleModal(item.id, item?.group?.name)}
                           className="action-button action-button-warning"
                           title={t("Edit") || "Edit"}>
                             <MdOutlineEdit size={20}/>
                         </button>}
                          {userPermissions?.edit &&
                            <button
                              onClick={() => openFunctionModal(item.id)}
                              className="action-button">
                              <MdSettings size={20} />
                            </button>}
                          
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              )}
            </table>
           
          </div>
        )}
      </div>
      <div className="pagination-controls mt-3 d-flex justify-content-center gap-2">
        <button
          className="btn btn-warning btn-sm text-white"
          onClick={() => setCurrentPage(0)}
          disabled={currentPage === 0}
        >
          {"<<"}
        </button>
        <button
          className="btn btn-warning btn-sm text-white"
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
          disabled={currentPage === 0}
        >
          {"<"}
        </button>
        <button
          className="btn btn-warning btn-sm text-white"
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1))}
          disabled={currentPage + 1 >= totalPages}
        >
          {">"}
        </button>
        <button
          className="btn btn-warning btn-sm text-white"
          onClick={() => setCurrentPage(totalPages - 1)}
          disabled={currentPage + 1 >= totalPages}
        >
          {">>"}
        </button>
        <span className="align-self-center">
          {t("User_Manage.page")} {currentPage + 1} {t("User_Manage.to")} {totalPages}
        </span>
      </div>

      <RoleModal
  isOpen={isModalOpen}
  toggle={() => setIsModalOpen(false)}
 
  selectedRole={selectedRole}
  onRoleChange={handleRoleChange}
/>
<Modal isOpen={isFunctionModalOpen} toggle={() => setIsFunctionModalOpen(false)}>
    <ModalHeader
    style={{ direction: 'ltr', paddingRight: '10px' }}
    toggle={() => setIsFunctionModalOpen(false)}
  >
    {t("Assign Functions")}
  </ModalHeader>
<div
  className="modal-body"
  style={{ maxHeight: '400px', overflowY: 'auto' }}
>
  {functionList.length === 0 ? (
    <p>No functions available or still loading...</p>
  ) : (
    functionList.map((fn: any) => (
      <div key={fn.id} className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={fn.id}
          checked={userFunctionIds.includes(fn.id)}
          onChange={() => toggleFunctionSelection(fn.id)}
        />
        <label className="form-check-label" htmlFor={fn.id}>
          {fn.name}
        </label>
      </div>
    ))
  )}
</div>
  <div className="modal-footer">
      <button className="mx-3 btnSubmit" onClick={submitUserFunctions}>
      Save
    </button>
    <button className="btn btn-gray btn-cancle rounded" onClick={() => setIsFunctionModalOpen(false)}>
      Cancel
    </button>
  
  </div>
</Modal>



    </>
  );
};

export default UserManage;
